// extracted by mini-css-extract-plugin
export var mainText = "index-module--mainText--3pxwm";
export var secondaryText = "index-module--secondaryText--2BB_o";
export var textContainer = "index-module--textContainer--3nqFd";